import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=79e5fe58&scoped=true&"
import script from "./videoList.vue?vue&type=script&lang=tsx&"
export * from "./videoList.vue?vue&type=script&lang=tsx&"
import style0 from "./videoList.vue?vue&type=style&index=0&id=79e5fe58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5fe58",
  null
  
)

export default component.exports